// React
import React, { Component } from "react";

// Libraries
import Scrollbar from 'react-smooth-scrollbar';

// Components
import { Pricer } from './';
import { Dropdown } from '../../Components';

// Stores
import { CurrencyStore, PricingStore } from '../../Stores';

// Utils
import { GoogleAnalytics } from '../../Utils';

// Stylesheets
import './pricer.css';
import './scrollbar-overrides.css';

// Prices Component
class Prices extends Component {

    constructor(props) {

        super(props);

        this.state = {
            currencies: {},
            exchange: PricingStore.getExchange(),
            exchanges: {
                "Kraken" : ['BTC', 'CAD', 'ETH', 'EUR', 'GBP', 'USD', 'JPY'],
                "Poloniex" : ['BTC', 'USD', 'XMR', 'ETH'],
                "BitTrex" : ['BTC'],
                "Coinbase" : ['USD', 'BTC'],
                "Binance" : ['USDT', 'BTC', 'BNB']
            },
            currency: PricingStore.getQuoteCurrency(),
            currencySymbols: CurrencyStore.getCurrencySymbols(),
            currencySymbol : CurrencyStore.getCurrencySymbol(PricingStore.getQuoteCurrency()),

            // sorting
            filterClass : "icon-sort-alpha-asc ",
            sort : 1,

            // errors
            message : null,
            timestamp: 0,

            // emitter
            emitter: null,
            emitterTokens: []
            
        };

        this.selectCurrency = this.selectCurrency.bind(this);
        this.selectExchange = this.selectExchange.bind(this);
        this.selectFilter = this.selectFilter.bind(this);
    }

/**********************************************************
 *  Lifecycle Functions
 **********************************************************/

    componentDidMount() {

        //console.log('Prices.componentDidMount()');

        CurrencyStore.getExchanges()
            .then( (exchanges) => {
                this.setState({
                    exchanges : exchanges
                });
            });

        this.init(this.state.exchange, this.state.currency, null);

    }

    // When Prices is unmounting, end connection
    componentWillUnmount() {

        //console.log('Prices.componentWillUnmount()');

        // Turn off all emitters
        //this.closeEmitters();
        
    }

    // Determines whether or not the Prices should update
    shouldComponentUpdate(nextProps, nextState) {

        // todo: kill socket upon each incoming change
        // and restart it with new topics

        if(nextState.currency !== this.state.currency || nextState.exchange !== this.state.exchange 
            || nextState.sort !== this.state.sort || this.state.timestamp !== nextState.timestamp
            || this.currenciesChange(this.state.currencies, nextState.currencies) || nextState.timestamp === -1 ) {
            //console.log('Prices.shouldComponentUpdate(true)');
            return true;
        }
        
        //console.log('Prices.shouldComponentUpdate(false)');
        return false;
    }

    
    componentDidUpdate(prevProps, prevState) {

        if(prevState.currency !== this.state.currency || prevState.exchange !== this.state.exchange)
            this.init(this.state.exchange, this.state.currency, null);

    }

/**********************************************************
 *  Functions
 **********************************************************/

  // Set initial socket connection for the Prices
  init(exchange, quoteCurrency, emitter) {

    PricingStore.getExchangePricesByQuote(exchange, quoteCurrency)
        .then( (prices) => {

            if(prices != null)
                return prices;
            else
                throw new Error('Prices null');

        }).then( (currencies) => {

            var prices = {};

            for(let[ticker, details] of Object.entries(currencies)) {
                prices[details.id] = {
                    price : details.price,
                    change : details.change,
                    timestamp : details.timestamp,
                    ticker : ticker,
                    topic : details.id,
                    name : details.name,
                    blink : true
                };
            }

            return prices;

        }).then( (currencies) => {

            emitter = PricingStore.getEmitter(this.state.emitterTokens);

            var emitterTokens = this.streamPriceUpdates(emitter, currencies);

            this.setState((prev, props) => {
                return {
                    currencies : currencies,
                    timestamp : currencies[Object.keys(currencies)[0]].timestamp,
                    emitter : emitter,
                    emitterTokens : emitterTokens
                }
            });

        }).catch( (error) => {
            
            this.setState((prev, props) => {
                return {
                    currencies : {},
                    timestamp : -1,
                    emitter : null,
                    emitterTokens : []
                }
            });

        });

  }


  // Listen for price updates for topic with emitter
  streamPriceUpdates(emitter, currencies) {
    
    //console.log('Prices.streamPriceUpdates()');

    const _this = this;

    var emitterTokens = [];

    for (let [topic, currency] of Object.entries(currencies)) {

        var token = emitter.addListener(currency.topic, function(newPriceObj) {
            
            const baseCurrency = newPriceObj.id.split('-')[0];
            const quoteCurrency = newPriceObj.id.split('-')[2];
            const priceExchange = newPriceObj.id.split('-')[1];

            if(newPriceObj.id === currency.topic && _this.state.currency === quoteCurrency
                && _this.state.exchange === priceExchange) {

                if(newPriceObj.price !== _this.state.currencies[newPriceObj.id].price) {

                    console.log('Price Updated - ' + currency.topic + '-' + newPriceObj.price);

                    var updated = {
                        price : newPriceObj.price,
                        change : newPriceObj.change,
                        timestamp : newPriceObj.timestamp,
                        ticker : currency.ticker,
                        topic : currency.topic,
                        name : currency.name,
                        blink : !currency.blink
                    };
                    
                    var updatedCurrencies = Object.assign({}, _this.state.currencies);
                    updatedCurrencies[currency.topic] = updated;

                    _this.setState((prev, props) => {
                        return {
                            currencies : updatedCurrencies
                        }
                    });

                }
    
            }
            else {
                console.log('Outdated Emitter Listener has been caught.');
            }
    
        });

        emitterTokens.push(token);


    }

    return emitterTokens;

}

  // Given two sets of currencies, return true if there
  // are any differences at currency property level
  currenciesChange(currencies, newCurrencies) {

    if(Object.keys(currencies).length !== Object.keys(newCurrencies).length)
        return true;
    else {

        for (let [topic, currency] of Object.entries(newCurrencies)) {

            if(currency != currencies[topic]) {
                return true;
            }
                
        }

    }

    return false;

  }

  // Closes all emitter tokens
  closeEmitters() {

    if(this.state.emitterTokens !== null) {

        var removeTokens = Object.assign({},this.state.emitterTokens);

        for(var token of this.state.emitterTokens) 
            token.remove();
    }

  }

/**********************************************************
 *  Selection Functions
 **********************************************************/

    // Set the Prices currency
    // Comes from PricesSettings
    selectCurrency(newCurrency) {

        if(newCurrency !== this.state.currency) {

            GoogleAnalytics.newAction('Prices', 'QuoteCurrency', newCurrency);

            // cache new quote currency
            PricingStore.setQuoteCurrency(newCurrency);

            this.setState((prev, props) => {
                return {
                    currency: newCurrency,
                    currencySymbol: this.state.currencySymbols[newCurrency]
                }       
            });

            this.init(this.state.exchange, newCurrency);

        }

    }


    // Set the Prices exchange
    // Comes from PricesSettings
    selectExchange(newExchange) {

        if(newExchange !== this.state.exchange) {
            
            // Log event to GA
            GoogleAnalytics.newAction('Prices', 'Exchange', newExchange);

            const defaultExchangeCurrency = this.state.exchanges[newExchange][0];

            // cache new exchange and quote currency
            PricingStore.setExchange(newExchange);
            PricingStore.setQuoteCurrency(defaultExchangeCurrency);

            this.setState((prev, props) => {
                return {
                    exchange: newExchange,
                    currency: defaultExchangeCurrency,
                    currencySymbol: this.state.currencySymbols[defaultExchangeCurrency]
                }
            });

            this.init(newExchange, defaultExchangeCurrency);
        }

    }


    // Selecting a filter icon class and sort type
    selectFilter(filterClass, sort) {

        // Log event to GA
        GoogleAnalytics.newAction('Prices', 'Filter', filterClass);

        this.setState((prevState,props) => {
            return {
                filterClass : filterClass,
                sort : sort
            }
        });

    }

/**********************************************************
 *  Sort Functions
 **********************************************************/

 // Given a collection of currencies, and sort type
 // return the sorted collection
 handleSort(unsorted, sort) {

    var currencies = [];
    
    Object.keys(unsorted).map( (key) => {

        currencies.push(unsorted[key]);

    });

    if(currencies.length > 0) {

        // A to Z
        if(sort === 1) {

            currencies.sort((a,b) => {
                if(a.ticker < b.ticker)
                    return -1;
                if(b.ticker < a.ticker)
                    return 1;
                return 0;
            });
            return currencies;

        }
        // Z to A
        else if(sort === 2) {

            currencies.sort((a,b) => {
                if(a.ticker > b.ticker)
                    return -1;
                if(b.ticker > a.ticker)
                    return 1;
                return 0;
            });
            return currencies;
        }
        else if(sort === 3) {

            currencies.sort((a,b) => {
                if(parseFloat(a.price) > parseFloat(b.price))
                    return -1;
                if(parseFloat(b.price) > parseFloat(a.price))
                    return 1;
                return 0;
            });
            return currencies;

        }
        else if(sort === 4) {

            currencies.sort((a,b) => {
                if(parseFloat(a.price) < parseFloat(b.price))
                    return -1;
                if(parseFloat(b.price) < parseFloat(a.price))
                    return 1;
                return 0;
            });
            return currencies;

        }
        else if(sort === 5) {
            
            currencies.sort((a,b) => {
                if(parseFloat(a.change) > parseFloat(b.change))
                    return -1;
                if(parseFloat(b.change) > parseFloat(a.change))
                    return 1;
                return 0;
            });
            return currencies;

        }
        else if(sort === 6) {
            
            currencies.sort((a,b) => {
                if(parseFloat(a.change) < parseFloat(b.change))
                    return -1;
                if(parseFloat(b.change) < parseFloat(a.change))
                    return 1;
                return 0;
            });
            return currencies;

        }
    }

    return currencies;

 }



/**********************************************************
 *  Render
 **********************************************************/

  render() {

    var currencies = this.handleSort(this.state.currencies, this.state.sort);

    const pricesHeight = window.innerHeight - 170;

    return (       
        <div>
        
            <div id='prices-heading' className="panel-heading">

                <div className="flex-menu">
                
                    {/*-----------  Dropdown Menu -----------id="chart-menu-row"*/}
                    <div className="flex-menu-row price-menu">

                        <Dropdown icon='icon-transmission' value={this.state.exchange}>
                        {
                            Object.keys(this.state.exchanges).sort().map((ex, id) => <li key={id} onClick={() => this.selectExchange(ex)}><a href={null}>{ex}</a></li>)
                        }
                        </Dropdown>

                        <Dropdown icon='icon-coins' value={this.state.currency}>
                        {
                            this.state.exchanges[this.state.exchange].sort().map((currency,id) => <li key={id} onClick={() => this.selectCurrency(currency)}><a href={null}><div className='currency-symbol'>{CurrencyStore.getCurrencySymbol(currency)}</div>{currency}</a></li>)
                        }
                        </Dropdown>

                        <Dropdown icon={this.state.filterClass} value={null} dropdownClasses={'dropdown-menu-right'}>
                            <li onClick={() => this.selectFilter("icon-sort-alpha-asc", 1)}>
                                <a href={null}><i className="icon-sort-alpha-asc"></i>A to Z</a>
                            </li>

                            <li onClick={() => this.selectFilter("icon-sort-alpha-desc", 2)}>
                                <a href={null}><i className=" icon-sort-alpha-desc"></i>Z to A</a>
                            </li>

                            <li onClick={() => this.selectFilter("icon-sort-numberic-desc", 3)}>
                                <a href={null}><i className="icon-sort-numberic-desc"></i>Price High</a>
                            </li>

                            <li onClick={() => this.selectFilter("icon-sort-numeric-asc", 4)}>
                                <a href={null}><i className="icon-sort-numeric-asc"></i>Price Low</a>
                            </li>

                            <li onClick={() => this.selectFilter("icon-sort-numberic-desc", 5)}>
                                <a href={null}><i className="icon-sort-numberic-desc"></i>Change High</a>
                            </li>

                            <li onClick={() => this.selectFilter("icon-sort-numeric-asc", 6)}>
                                <a href={null}><i className="icon-sort-numeric-asc"></i>Change Low</a>
                            </li>
                        </Dropdown>

                    </div>
                </div>

            </div>
                                
            <Scrollbar damping={0.1} thumbMinSize={20} continuousScrolling={true} renderByPixels={false} alwaysShowTracks={false}>

                <div className="panel-body prices-body" style={{ height: pricesHeight, paddingTop: 0, overflowY: 'visible' }}  >   
                
                    {
                        currencies.map( (currency) => {
                                return (
                                    <Pricer currency={currency} key={currency.topic} currencySymbol={this.state.currencySymbol}/>
                                )
                        })
                    }
                
                </div>
                
            </Scrollbar>
            

        </div>

        

    );
  }
}

export default Prices;



// WEBPACK FOOTER //
// ./src/Views/Prices/Prices.js